import React from "react";
import { NavLink } from "react-router-dom";

export default function CyberSecurityTrainingConsulting() {
  return (
    <section className="container page-top pt-10" style={{ paddingTop: "6rem" }}>
      <div className="container">
        {/* Title Section */}
        <div className="row mb-4">
          <div className="col-12 text-center">
            <h1 className="display-5 fw-bold text-primary">Cyber Security Training & Consulting</h1>
            <h5 className="text-muted">
              Secure Your Digital Landscape with Expert Guidance and Training
            </h5>
            <hr className="w-25 mx-auto" />
          </div>
        </div>

        {/* Image and Introduction */}
        <div className="row align-items-center mb-5">
          <div className="col-md-6">
            <img
              src="https://img.freepik.com/free-vector/cyber-security-concept_23-2148532223.jpg"
              alt="Cyber Security"
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6">
            <h2 className="fw-semibold">Proactive Defense Through Knowledge & Expertise</h2>
            <p>
              <strong>Bytlas Intelligence</strong> offers comprehensive Cyber Security Training and
              Consulting tailored for businesses of all sizes. From awareness to advanced threat detection,
              we help organizations build resilient digital ecosystems.
            </p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ Certified Training for Employees & IT Teams</li>
              <li className="list-group-item">✅ Risk Assessment & Vulnerability Management</li>
              <li className="list-group-item">✅ Data Protection & Compliance Guidance</li>
              <li className="list-group-item">✅ Incident Response & Cyber Forensics</li>
            </ul>
          </div>
        </div>

        {/* Features Section */}
        <div className="row my-5">
          <div className="col-md-6">
            <h3 className="text-secondary">Train Your Team — Fortify Your Business</h3>
            <p>
              Our certified trainers deliver interactive sessions designed to educate and empower your workforce. 
              From phishing simulations to endpoint security best practices, our training adapts to your needs.
            </p>
            <ul>
              <li>🛡️ Cyber Awareness Webinars</li>
              <li>👨‍🏫 Certified Ethical Hacking & Pen Testing Workshops</li>
              <li>📋 Policy & Compliance Workshops (ISO, GDPR, etc.)</li>
              <li>🔐 Secure Coding & AppSec Training for Developers</li>
            </ul>
          </div>

          <div className="col-md-6">
            <h3 className="text-secondary">Expert-Led Cyber Consulting</h3>
            <p>
              Our security specialists work with you to assess, improve, and monitor your security posture. 
              We help design policies, configure firewalls, and respond to threats quickly and effectively.
            </p>
            <ul>
              <li>🔍 Security Audits & Infrastructure Review</li>
              <li>💼 Customized InfoSec Strategies</li>
              <li>📊 Compliance Readiness Reports</li>
              <li>⚙️ Managed Security Services (MSSP)</li>
            </ul>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-4">
          <NavLink to="/contact" className="btn btn-danger px-4 py-2 rounded-pill fw-bold">
            Schedule Your Security Consultation
          </NavLink>
        </div>
      </div>
    </section>
  );
}
